export default "__VITE_ASSET__dcc992cb__"